import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { DailyPicksPage } from '../features/daily-picks/page'

export const dailyPicksRoute = createRoute({
  path: 'daily-picks',
  getParentRoute: () => rootRoute,
  component: DailyPicksPage,
})
